import { render, staticRenderFns } from "./DeliveryWindowQuery.vue?vue&type=template&id=15b96ee9&scoped=true"
import script from "./DeliveryWindowQuery.vue?vue&type=script&lang=js"
export * from "./DeliveryWindowQuery.vue?vue&type=script&lang=js"
import style0 from "./DeliveryWindowQuery.vue?vue&type=style&index=0&id=15b96ee9&prod&lang=scss&scoped=true"
import style1 from "./DeliveryWindowQuery.vue?vue&type=style&index=1&id=15b96ee9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b96ee9",
  null
  
)

export default component.exports